import { createPopper } from "@popperjs/core";
import * as bootstrap from "bootstrap";
import ScrollOut from "scroll-out";
import "@lottiefiles/lottie-player";
import "./components/accordion";
import "./components/header";
import "./components/image-swap";
import "./components/leadership-card";
import "./components/sliders";
import "./components/search";
import "./components/counter";
import "./components/ip";

const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

window.onload = function() {
  ScrollOut( {
    once: true,
    threshold: 0.3,
  })
}

document.addEventListener("htmx:configRequest", (event) => {
  event.detail.headers["X-WP-Nonce"] = WP_REST.nonce;
});

function download_file(media_url) {
  fetch(media_url)
    .then((res) => res.blob())
    .then((blob) => {
      let objectURL = URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectURL;
      a.download = media_url.substring(media_url.lastIndexOf("/") + 1);
      a.setAttribute("target", "_blank");
      a.click();
    });
}

// trigger a resize event on the window to force a re-render of the survey block with external script, Block editor is weird :D
(function ($) {
  $(document).ready(function () {
    if (typeof wp === "undefined") {
      return;
    }

    if (typeof wp?.data === "undefined") {
      return;
    }

    if (wp?.data?.select && typeof wp.data.select === "function") {
      // Wait for blocks to be available
      const { subscribe } = wp?.data;

      const unsubscribe = subscribe(() => {

        const select = wp.data.select("core/block-editor");

        if (!select) {
          return;
        }
        const blocks = select.getBlocks();

        // Check if blocks are available
        if (blocks.length > 0) {
          // Stop subscribing once we have blocks
          unsubscribe();

          // Loop through blocks to find your specific block
          blocks.forEach((block) => {
            if (block.name === "akeneo/survey-embed") {
              // Force a re-render of the block
              // trigger a screen resize event
              window.dispatchEvent(new Event("resize"));
            }
          });
        }
      });
    }
  });
})(jQuery);
